import { defineFcm } from '../shared/factory';

export const FCM_PAYMENTS_SAVE_PAYMENT_CHECKMARK_CONFIG = defineFcm('payments_save_payment_checkmark_config')
	.asBoolean()
	.withDefault(true)
	.toConfig();
